import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { idSelector } from "../../../selectors/hostSelectors";
import IpDetail from "./IpDetail";
import IPs from "./IPs";

const IPsView = (props) => {
  const { hostId } = props;

  if (hostId) {
    return <IpDetail />;
  }

  return (
    <div className="resources-view">
      <IPs />
    </div>
  );
};

IPsView.propTypes = {
  hostId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

IPsView.defaultProps = {
  hostId: "",
};

const mapStateToProps = (state) => {
  const hostId = idSelector(state);

  return {
    hostId,
  };
};

export default connect(mapStateToProps, null)(IPsView);
